import Icon from '../../components/Icon.vue'

Icon.register({"regular/money-bill-alt":{"width":640,"height":512,"paths":[{"d":"M320 144C267 144 224 194.1 224 256 224 317.9 267 368 320 368 373 368 416 317.9 416 256 416 194.1 373 144 320 144zM360 312C360 316.4 356.4 320 352 320H288C283.6 320 280 316.4 280 312V296C280 291.6 283.6 288 288 288H304V232.6L303.5 232.9A8-8 0 0 0 292.4 230.7L283.6 217.3A8-8 0 0 0 285.8 206.3L301.1 196A24-24 0 0 0 314.4 192H328C332.4 192 336 195.6 336 200V288H352C356.4 288 360 291.6 360 296V312zM608 64H32C14.3 64 0 78.3 0 96V416C0 433.7 14.3 448 32 448H608C625.7 448 640 433.7 640 416V96C640 78.3 625.7 64 608 64zM592 336C556.6 336 528 364.6 528 400H112C112 364.6 83.3 336 48 336V176C83.3 176 112 147.4 112 112H528C528 147.4 556.6 176 592 176V336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/money-bill-alt.js
// module id = pS8R
// module chunks = 0